import React, { useState } from 'react';
import { Wrench, Gauge, History } from 'lucide-react';
import ReportesTab from './ReportesTab';
import VehiculosTab from './VehiculosTab';
import ReportesKmTab from './ReportesKmTab';
import '../AssetsView.css';

const TABS = [
  { key: 'reportes', label: 'Reportes', icon: Wrench, Component: ReportesTab },
  { key: 'vehiculos', label: 'Vehículos y KM', icon: Gauge, Component: VehiculosTab },
  { key: 'reportes-km', label: 'Reportes de KM', icon: History, Component: ReportesKmTab },
];

const EquiposMovilesView = () => {
  const [activeTab, setActiveTab] = useState('reportes');

  return (
    <div className="assets-view">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 m-0">Equipos Móviles</h1>
        <p className="text-gray-400 text-sm m-0 mt-1">Servicios Generales — mantenimiento y kilometraje</p>
      </div>

      {/* Tabs */}
      <div className="flex bg-gray-100 rounded-2xl p-1.5 w-fit mb-6 gap-1">
        {TABS.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2.5 px-6 py-3 rounded-xl text-base font-semibold transition-all ${
                isActive ? 'text-white shadow-md bg-gradient-to-br from-sura-blue to-sura-blue-light' : 'text-gray-500 hover:text-gray-800 hover:bg-white/60'
              }`}
            >
              <Icon size={20} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {(() => {
        const ActiveComponent = TABS.find(t => t.key === activeTab)?.Component;
        return ActiveComponent ? <ActiveComponent /> : null;
      })()}
    </div>
  );
};

export default EquiposMovilesView;
